module.exports = __webpack_public_path__ + "static/media/logo-verde.3e2fd77d.svg";